export default class EscPosEncoder {
  constructor() {
    this.buffer = [];
  }

  // Add raw bytes to buffer
  _add(bytes) {
    this.buffer.push(...bytes);
    return this;
  }

  // Initialize printer
  initialize() {
    return this._add([0x1B, 0x40]);
  }

  // Align text (0: left, 1: center, 2: right)
  align(mode) {
    return this._add([0x1B, 0x61, mode]);
  }

  // Bold text (true/false)
  bold(on) {
    return this._add([0x1B, 0x45, on ? 1 : 0]);
  }

  // Text size (normal, large)
  size(mode) {
    let m = 0;
    if (mode === 'large') m = 0x11; // Double width & height
    else if (mode === 'tall') m = 0x01; // Double height
    else if (mode === 'wide') m = 0x10; // Double width
    return this._add([0x1D, 0x21, m]);
  }

  // Print text (ASCII only for simplicity, or utf-8 encoded depending on printer)
  text(str) {
    for (let i = 0; i < str.length; i++) {
      this.buffer.push(str.charCodeAt(i));
    }
    return this;
  }

  // Print text with line feed
  line(str = '') {
    this.text(str);
    return this._add([0x0A]);
  }

  // Full paper cut
  cut() {
    // Add some line feeds before cut to ensure it clears the blade
    this._add([0x0A, 0x0A, 0x0A, 0x0A]);
    return this._add([0x1D, 0x56, 0x00]); // Full cut
  }

  // Output as Uint8Array for Web Bluetooth
  encode() {
    return new Uint8Array(this.buffer);
  }
}
